export interface IMarkAsRead {
    aggId: string;
    unread: any;
}

export class MarkAsRead implements IMarkAsRead {
    aggId: string;
    unread: any;
}